export default "__VITE_ASSET__DhY4ukhP__"